const $accordion = $(".js-accordion-footer");
const $win = $(window);

/**
 * Footer Accordion
 *
 * @return {Void}
 */

if ($win.width() < 1024) {
  $accordion.find(".js-accordion-head").on("click", function (event) {
    const $this = $(this);

    if (!$this.hasClass("is-active")) {
      event.preventDefault();
    }

    $this.toggleClass("is-active");

    $this
      .closest(".js-accordion-footer")
      .find(".js-accordion-body")
      .slideToggle();
  });
}
